import { useRef } from "react";
import { motion, useScroll } from "framer-motion";
import { STEPS } from "@/data/services";
import { SectionHead, Reveal } from "@/components/ui/motion";

const Meta = ({ label, text }) => (
  <div>
    <p className="text-[11px] font-bold uppercase tracking-[0.18em] text-accentb">{label}</p>
    <p className="mt-1.5 text-[14.5px] leading-relaxed text-ink">{text}</p>
  </div>
);

export const Timeline = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start 75%", "end 55%"] });
  return (
    <section id="cara-kerja" className="relative bg-ice py-20 sm:py-28 lg:py-36" data-testid="timeline-section">
      <div className="wrap">
        <SectionHead eyebrow="Cara Kerja" title={<>Langkah yang Jelas, Proses yang <span className="serif-it font-normal text-accentb">Lebih Terarah.</span></>} desc="Lima tahap yang membantu Anda memahami setiap langkah. Hasil penyelesaian tetap bergantung pada persetujuan kreditur." />
        <div ref={ref} className="relative mt-16 lg:mt-24">
          <div className="absolute bottom-0 left-[19px] top-0 w-px bg-line sm:left-[27px]" aria-hidden="true" />
          <motion.div style={{ scaleY: scrollYProgress }} className="absolute bottom-0 left-[19px] top-0 w-px origin-top bg-sky-brand sm:left-[27px]" aria-hidden="true" />
          <ol className="space-y-6">
            {STEPS.map((s) => (
              <Reveal key={s.no}>
                <li className="relative grid grid-cols-[40px_1fr] gap-5 sm:grid-cols-[56px_1fr] sm:gap-8" data-testid={`timeline-step-${s.no}`}>
                  <span className="relative z-10 grid h-10 w-10 place-items-center rounded-full border border-line bg-white font-display text-[13px] font-bold text-slateb sm:h-14 sm:w-14 sm:text-base">{s.no}</span>
                  <div className="card grid gap-6 p-6 sm:p-8 lg:grid-cols-12 lg:items-start">
                    <h3 className="font-display text-2xl font-bold lg:col-span-4 lg:text-[28px]">{s.title}</h3>
                    <div className="grid gap-5 sm:grid-cols-3 lg:col-span-8">
                      <Meta label="Yang dilakukan" text={s.what} />
                      <Meta label="Yang dibutuhkan" text={s.need} />
                      <Meta label="Yang dapat diharapkan" text={s.expect} />
                    </div>
                  </div>
                </li>
              </Reveal>
            ))}
          </ol>
        </div>
      </div>
    </section>
  );
};
